import { createRouter, createWebHistory } from 'vue-router'
import authGuard from './guard'
import ViewDashboard from '@/views/ViewDashboard.vue'
import ViewNotFound from '@/views/ViewNotFound.vue'
import stockRoutes from './stock'
import stocktakeRoutes from './stocktake'
import yardWorkspaceRoutes from './yard-workspace'
import hireDeskRoutes from './hire-desk'
import yardAppRoutes from './yard-app'
import driverAppRoutes from './driver-app'
import productDataRoutes from './product-data'
import ViewJourneyPlanner from '@/views/ViewJourneyPlanner.vue'
import ViewFiles from '@/views/ViewFiles.vue'
import ViewMarketingLists from '@/views/ViewMarketingLists.vue'
import ViewItem from '@/views/stock/ViewItem.vue'
import ItemService from '@/services/item'

let router

const hostname = window.location.hostname


if (hostname === import.meta.env.VITE_STOCK_DOMAIN) {
	router = createRouter({
		history: createWebHistory(import.meta.env.BASE_URL),
		routes: [
			{
				path: '/product-data/items/:code(.*)',
				name: 'item',
				component: ViewItem,
				beforeEnter: async (to, from, next) => {
					const code =
						typeof to.params.code === 'string' ? to.params.code : to.params.code[0]
					const api = new ItemService()
					await api
						.get(code)
						.then((res: any) => {
							to.meta.item = res.data.data
							next()
						})
						.catch(() => {
							next({ name: 'not-found' })
						})
				}
			},
			{
				path: '/:notFound(.*)*',
				name: 'not-found',
				component: ViewNotFound
			}
		]
	})
} else {
	router = createRouter({
		history: createWebHistory(import.meta.env.BASE_URL),
		routes: [
			{
				path: '/',
				name: 'dashboard',
				component: ViewDashboard,
				meta: {
					permissions: []
				}
			},
			...stockRoutes,
			...stocktakeRoutes,
			...hireDeskRoutes,
			...yardWorkspaceRoutes,
			...yardAppRoutes,
			...driverAppRoutes,
			...productDataRoutes,
			{
				path: '/journey-planner',
				name: 'journey-planner',
				component: ViewJourneyPlanner,
				meta: {
					permissions: ['view-journey-planner']
				}
			},
			{
				path: '/files',
				name: 'files',
				component: ViewFiles,
				meta: {
					permissions: []
				}
			},
			{
				path: '/marketing-lists',
				name: 'marketing-lists',
				component: ViewMarketingLists,
				meta: {
					permissions: ['view-mailchimp']
				}
			},
			{
				path: '/:notFound(.*)*',
				name: 'not-found',
				component: ViewNotFound,
				meta: {
					navigation: false
				}
			}
		]
	})

	router.beforeEach(authGuard)
}

export default router
